<script>
    export default {
        props: {
            activatorColor: {
                type: String,
                default: "#000"
            }
        },

        data: () => ({
            sheet: false,
            tiles: [
                {
                    to: "/administracao",
                    icon: "how_to_reg",
                    title: "Administração"
                },
                { to: "/vendas", icon: "shopping_cart", title: "Vendas" },
                { to: "/estoque", icon: "assignment", title: "Estoque" },
                { to: "/financas", icon: "attach_money", title: "Finanças" }
            ]
        })
    };
</script>

<template>
    <div class='text-xs-center'>
        <v-bottom-sheet v-model='sheet'>
            <template v-slot:activator>
                <v-btn aria-hidden='true' flat icon :color='activatorColor'>
                    <v-icon>menu</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-subheader>Ir para ...</v-subheader>
                <v-list-tile v-for='tile in tiles' :key='tile.title' @click='sheet = false'>
                    <router-link :to='tile.to' class='fluid__item'>
                        <v-list-tile-avatar>
                            <i aria-hidden='true' class='material-icons'>{{ tile.icon }}</i>
                        </v-list-tile-avatar>
                        <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
                    </router-link>
                </v-list-tile>
            </v-list>
        </v-bottom-sheet>
    </div>
</template>

<style>
    .fluid__item {
        all: unset;
        text-decoration: none;
        width: 100%;
        display: flex;
        align-items: center;
    }
    .theme--dark.application .fluid__item {
        color: white;
    }
    .theme--light.application .fluid__item {
        color: #252525;
    }
</style>
